import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Phone, Menu, X, ChevronDown } from 'lucide-react';
import { company } from '../../mock';
import { Button } from '../ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../ui/dropdown-menu';

const nav = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/services', label: 'Services' },
  // { to: '/projects', label: 'Projects' },
  { to: '/blog', label: 'Blog' },
  { to: '/contact', label: 'Contact' },
];

const more = [
  { to: '/media', label: 'Gallery' },
  { to: '/investors', label: 'Investors' },
  { to: '/careers', label: 'Careers' },
  { to: '/faqs', label: 'FAQs' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled ? 'bg-[#0f1a14]/90 backdrop-blur border-b border-white/5' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <Link to="/" className="flex items-center gap-3 group">
          <div className="h-10 w-10 rounded-full bg-white grid place-items-center text-[#0f1a14] font-serif text-lg font-bold">
            <img src="/logo.svg" alt="" />
          </div>
          <div className="leading-tight">
            <div className="font-serif text-lg text-white tracking-wide">Ewen Realtors</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-[#c9a56a]">RERA {company.rera.slice(-6)}</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === '/'}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors ${
                  isActive ? 'text-[#c9a56a]' : 'text-white/80 hover:text-white'
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
          <DropdownMenu>
            <DropdownMenuTrigger className="flex items-center gap-1 text-sm text-white/80 hover:text-white outline-none">
              More <ChevronDown className="h-3 w-3" />
            </DropdownMenuTrigger>
            <DropdownMenuContent className="bg-[#0f1a14] border-white/10 text-white/80 rounded-none min-w-[180px]">
              {more.map((m) => (
                <DropdownMenuItem key={m.to} asChild className="focus:bg-[#1c2e26] focus:text-[#c9a56a] cursor-pointer">
                  <Link to={m.to} className="text-sm">{m.label}</Link>
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a href={`tel:${company.phone}`} className="flex items-center gap-2 text-white/80 hover:text-white text-sm">
            <Phone className="h-4 w-4" />
            {company.phone}
          </a>
          <Link to="/contact">
            <Button className="bg-[#c9a56a] text-[#0f1a14] hover:bg-[#b8945a] rounded-none px-6">Book a Visit</Button>
          </Link>
        </div>

        <button onClick={() => setOpen(!open)} className="lg:hidden text-white">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0f1a14] border-t border-white/10">
          <div className="px-6 py-6 flex flex-col gap-4">
            {[...nav, ...more].map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className="text-white/80 hover:text-[#c9a56a] text-sm"
              >
                {n.label}
              </NavLink>
            ))}
            <a href={`tel:${company.phone}`} className="text-[#c9a56a] text-sm flex items-center gap-2">
              <Phone className="h-4 w-4" /> {company.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
